import api from '../../plugins/api';

const createComplectationOptions = (params) => {
  return api.post('/api/crm/cars/createComplectationOptions', params);
};

export default createComplectationOptions;
